import { SelectOption } from '@/components/ui/select'

import { SaltoSpaceAccessItem, SaltoSpaceIntegration } from './provider-connections'
import { SaltoFormData } from './salto-space.types'

const toIds = (items: SaltoSpaceAccessItem[]) => items.map(({ saltoId }) => saltoId)

export const getDefaults = (integration: SaltoSpaceIntegration | undefined): SaltoFormData => ({
  apiKey: integration?.apiKey ?? '',
  residentAccessLevels: toIds(integration?.config.accessLevels ?? []),
  residentZones: toIds(integration?.config.permissionGroups ?? []),
  shouldAutoAssignApartmentDoor: integration?.config.shouldAutoAssignApartmentDoor ?? false,
  shouldAutoAssignUserAccessLevel: integration?.config.shouldAutoAssignUserAccessLevel ?? false,
  url: integration?.url ?? '',
  visitorAccessLevels: toIds(integration?.config.visitorAccessLevels ?? []),
  visitorZones: toIds(integration?.config.visitorPermissionGroups ?? []),
})

export const withStoredItems = (
  available: SaltoSpaceAccessItem[],
  stored: SaltoSpaceAccessItem[],
): SelectOption<string>[] => {
  const merged = new Map<string, string>()
  stored.forEach(({ name, saltoId }) => merged.set(saltoId, name))
  available.forEach(({ name, saltoId }) => merged.set(saltoId, name))
  return [...merged].map(([value, label]) => ({ label, value }))
}

export const toItems = (ids: string[], options: SelectOption<string>[]): SaltoSpaceAccessItem[] =>
  ids.map((saltoId) => ({
    name: options.find((option) => option.value === saltoId)?.label ?? saltoId,
    saltoId,
  }))
